var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00644 11V9.928C1.71044 9.24533 2.3451 8.616 2.91044 8.04C3.48644 7.464 3.97177 6.93067 4.36644 6.44C4.77177 5.94933 5.0811 5.49067 5.29444 5.064C5.50777 4.63733 5.61444 4.232 5.61444 3.848C5.61444 3.304 5.47044 2.87733 5.18244 2.568C4.89444 2.248 4.47844 2.088 3.93444 2.088C3.53977 2.088 3.1771 2.2 2.84644 2.424C2.52644 2.648 2.22777 2.91467 1.95044 3.224L0.926437 2.2C1.39577 1.69867 1.87577 1.31467 2.36644 1.048C2.86777 0.770666 3.47044 0.632 4.17444 0.632C4.6651 0.632 5.10777 0.706667 5.50244 0.856C5.8971 1.00533 6.2331 1.21867 6.51044 1.496C6.78777 1.76267 7.0011 2.088 7.15044 2.472C7.31044 2.856 7.39044 3.28267 7.39044 3.752C7.39044 4.2 7.2891 4.65867 7.08644 5.128C6.89444 5.58667 6.62777 6.056 6.28644 6.536C5.95577 7.00533 5.56644 7.49067 5.11844 7.992C4.67044 8.49333 4.19577 9.01067 3.69444 9.544C3.9611 9.52267 4.2491 9.50133 4.55844 9.48C4.86777 9.448 5.1451 9.432 5.39044 9.432H7.88644V11H1.00644Z",
    fill: "#008381"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.b6943fea.svg";
export { ForwardRef as ReactComponent };